import PhoneIcon from '../assets/images/customer-support.png'
import SecurityIcon from '../assets/images/security.png'
import FollowerIcon from '../assets/images/followers.png'
import ContentIcon from '../assets/images/content-management.png'
import TargetIcon from '../assets/images/target-audience.png'
import PlanIcon from '../assets/images/payment-plan.png'

const features = [
    {
        name: 'Flexible plans',
        description:
            'Three kinds of plans which you can test and change anytime. You can also have special plans crafted for you',
        icon: PlanIcon,
    },
    {
        name: 'Targeted audience',
        description:
            'The audience which craves your content day and night. We target people who love your content',
        icon: TargetIcon,
    },
    {
        name: 'Content management',
        description:
            'Organized content and no more messy photo galleries. We will take care of all your content',
        icon: ContentIcon,
    },
    {
        name: 'Organic followers',
        description:
            'Receive real followers on your Instagram profile instantly within minutes. The real people who are ready to engage',
        icon: FollowerIcon,
    },
    {
        name: 'Advanced security',
        description:
            'Real people, real views, real likes and follows. Your account is 100% secure and authentic in any way possible',
        icon: SecurityIcon,
    },

    {
        name: '24/7 support',
        description:
            'Having new ideas and want to impement them asap? We are ready to make your dreams come true 24/7',
        icon: PhoneIcon,
    },
]

export default features;